"use client";
import React, { useEffect, useState } from "react";
import styles from "./Facts.module.scss";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

const generateRandomStrip = (targetDigit: number) => {
  const length = Math.floor(Math.random() * 11) + 20; // 20 to 30 items
  const strip = [];
  for (let i = 0; i < length - 1; i++) {
    strip.push(DIGITS[Math.floor(Math.random() * 10)]);
  }
  strip.push(targetDigit);
  return strip;
};

export const RunningDigit = ({ value }: { value: string | number }) => {
  const { ref, isInView } = useScrollAnimation({
    triggerOnce: true,
    threshold: 0.1,
  });
  const [isAnimating, setIsAnimating] = useState(false);

  // Logic to parse value
  const valStr = String(value);

  // Generate strips once per value
  const [strips, setStrips] = useState<(number[] | null)[] | null>(null);

  useEffect(() => {
    const newStrips = valStr.split("").map((char) => {
      if (!/[0-9]/.test(char)) return null;
      return generateRandomStrip(parseInt(char, 10));
    });
    setStrips(newStrips);
  }, [valStr]);

  useEffect(() => {
    if (isInView) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 2500); // 2.5s duration matches transition
      return () => clearTimeout(timer);
    }
  }, [isInView]);

  return (
    <span
      ref={ref}
      className={`${styles["running-digit-wrapper"]} ${isAnimating ? styles["animating"] : ""}`}
      style={{ display: "inline-flex" }}
    >
      {valStr.split("").map((char, index) => {
        if (!strips || !strips[index]) {
          return <span key={index}>{char}</span>;
        }

        const strip = strips[index];

        const stripLen = strip.length;
        const translation = ((stripLen - 1) * 100) / stripLen;

        return (
          <span key={index} className={styles["digit-slot"]}>
            <span
              className={styles["digit-column"]}
              style={{
                transform: isInView
                  ? `translateY(-${translation}%)`
                  : `translateY(0%)`,
              }}
            >
              {strip.map((n, i) => (
                <span
                  key={i}
                  className={styles["digit"]}
                  style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {n}
                </span>
              ))}
            </span>
          </span>
        );
      })}
    </span>
  );
};
